module.exports = __webpack_public_path__ + "static/media/sme.5ef9673a.jpg";